import React, { useState, useEffect } from "react";
import DataTables from "./components/UsersTables";
import Edit from "./modals/Edit";
import View from "./modals/View";
import Delete from "./modals/Remove";
import Create from "./modals/Create";
import Filter from "./modals/Filter";
import ChangePassword from "./modals/ChangePassword";
import Divider from "@material-ui/core/Divider/index";
// import Switch from "@material-ui/core/Switch/index";
// import FormControlLabel from "@material-ui/core/FormControlLabel/index";
import axios from "axios";
import { v4 as uuid } from "uuid";
import { updateObject } from "../../../helpers/updateObject";

export function Users() {
  const [showEdit, setShowEdit] = useState(false);
  const [showView, setShowView] = React.useState(false);
  const [showRemove, setShowRemove] = useState(false);
  const [showCreate, setShowCreate] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [showFilter, setShowFilter] = useState(false);

  function handleChange() {
    setShowFilter((key) => !key);
  }

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setShowView(open);
  };

  const [error, setError] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [sortFiled, setSortFiled] = useState("id");
  const [orderBy, setOrderBy] = useState(false);
  const [rows, setRows] = useState([]);
  const [user, setUser] = useState({});
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(10);
  const [count, setCount] = useState(0);
  const [userId, setUserId] = useState(null);
  const [deleteUsersIds, setDeleteUsersIds] = useState([]);
  const [filter, setFilter] = useState(false);
  const [filterInputs, setFilterInputs] = useState({
    firstName: "",
    lastName: "",
    email: "",
    roleId: "",
  });

  const onUsers = (skip, take, sortFiled, orderBy) => {
    setIsLoaded(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}user?Skip=${skip}&Take=${take}&SortField=${sortFiled}&OrderBy=${orderBy}`,
        {
          headers: {
            "Accept-Language": 1,
          },
        }
      )
      .then(
        ({ data: { data, totalCount } }) => {
          setIsLoaded(false);
          setRows(data);
          setCount(totalCount);
          setError(false);
        },
        (error) => {
          setIsLoaded(false);
          setError(true);
          setRows([]);
          setCount(0);
        }
      );
  };
  const onFilter = (skip, take, sortFiled, orderBy, filterInputs) => {
    setIsLoaded(true);
    const { firstName, lastName, email, roleId } = filterInputs;
    axios
      .get(
        `${process.env.REACT_APP_API_URL}user/filter?Skip=${skip}&Take=${take}&SortField=${sortFiled}&OrderBy=${orderBy}&FirstName=${firstName}&LastName=${lastName}&Email=${email}&RoleId=${roleId}`,
        {
          headers: {
            "Accept-Language": 1,
          },
        }
      )
      .then(
        ({ data: { data, totalCount } }) => {
          setIsLoaded(false);
          setRows(data);
          setCount(totalCount);
          setError(false);
        },
        (error) => {
          setIsLoaded(false);
          setError(true);
          setRows([]);
          setCount(0);
        }
      );
  };

  const onUserChoose = (id) => {
    axios
      .get(`${process.env.REACT_APP_API_URL}user/${id}`)
      .then(({ data }) => {
        setUser(data);
      });
  };

  const onUpdateUserStatus = (id, statusType) => {
    let isActive = !statusType;
    axios
      .patch(
        `${process.env.REACT_APP_API_URL}user/active`,
        {
          id,
          isActive
        },
        {
          headers: {
            "x-requestid": uuid(),
          },
        }
      )
      .then(() => {
        onUsers(skip, take, sortFiled, orderBy);
      });
  };

  const onDeleteUsers = () => {
    axios
      .delete(`${process.env.REACT_APP_API_URL}user`, {
        headers: {
          "x-requestid": uuid(),
        },
        data: {
          id: deleteUsersIds,
        },
      })
      .then((res) => {
        setDeleteUsersIds([]);
        onUsers(skip, take, sortFiled, orderBy);
      });
  };

  const filterInputsUpdate = (e) => {
    const updateFiltersInput = updateObject(filterInputs, {
      [e.target.name]: e.target.value,
    });

    setFilterInputs(updateFiltersInput);
    setSkip(0);
    setFilter(true);
  };

  useEffect(() => {
    if (filter) {
      const timer = setTimeout(() => {
        onFilter(skip, take, sortFiled, orderBy, filterInputs);
      }, 500);

      return () => clearTimeout(timer);
    } else {
      onUsers(skip, take, sortFiled, orderBy);
    }
  }, [skip, take, sortFiled, orderBy, filter, filterInputs]);

  useEffect(() => {
    if (!showView || !showEdit) setUser({});
  }, [showView, showEdit]);

  const onUsersExport = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}user/export`, {
        responseType: "blob",
      })
      .then((res) => {
        var url = window.URL.createObjectURL(new Blob([res.data]));
        var a = document.createElement("a");
        a.href = url;
        a.download = "Users.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
      });
  };

  return (
    <div className="row bg-white rounded">
      <div className="col-12 d-flex align-items-center py-4">
        <h1 className="display-4 mb-0">Users</h1>
        {/* <FormControlLabel
          control={
            <Switch
              checked={showFilter}
              onChange={handleChange}
              color="secondary"
            />
          }
          label={showFilter ? "Hide filter" : "Show filter"}
          className="ml-auto mb-0"
        /> */}
      </div>
      <Divider className="w-100" />
      <DataTables
        setSortFiled={setSortFiled}
        setOrderByTable={setOrderBy}
        sortFiled={sortFiled}
        orderBy={orderBy}
        setOpenEdit={setShowEdit}
        setOpenView={toggleDrawer(true)}
        setOpenRemove={setShowRemove}
        setOpenCreate={setShowCreate}
        setOpenChangePassword={setShowChangePassword}
        isLoaded={isLoaded}
        error={error}
        rows={rows}
        onUserChoose={onUserChoose}
        updateSkip={setSkip}
        updateTake={setTake}
        count={count}
        onUpdateUserStatus={onUpdateUserStatus}
        setUserId={setUserId}
        setDeleteUsersID={setDeleteUsersIds}
        deleteUsersIds={deleteUsersIds}
        onDeleteUsers={onDeleteUsers}
        onUsersExport={onUsersExport}
      />
      <Edit
        user={user}
        show={showEdit}
        onHide={setShowEdit}
        skip={skip}
        take={take}
        sortFiled={sortFiled}
        orderBy={orderBy}
        onUsers={onUsers}
      />

      <View user={user} open={showView} onClose={toggleDrawer(false)} />
      <Delete
        id={userId}
        show={showRemove}
        onHide={setShowRemove}
        skip={skip}
        take={take}
        sortFiled={sortFiled}
        orderBy={orderBy}
        onUsers={onUsers}
      />
      <Create
        show={showCreate}
        onHide={setShowCreate}
        onUsers={onUsers}
        skip={skip}
        take={take}
        sortFiled={sortFiled}
        orderBy={orderBy}
      />
      <Filter
        show={showFilter}
        onHide={handleChange}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
      />
      <ChangePassword
        show={showChangePassword}
        onHide={setShowChangePassword}
        id={userId}
      />
    </div>
  );
}
